/**
 * Opt-in verbose logging for interviewer calendar fetch / cache.
 *
 * Enable in the browser console:
 *   localStorage.setItem('DEBUG_CALENDAR_EVENTS', '1')
 * Disable:
 *   localStorage.removeItem('DEBUG_CALENDAR_EVENTS')
 */
const LS_KEY = 'DEBUG_CALENDAR_EVENTS';

export function isCalendarEventsDebugEnabled(): boolean {
  try {
    return (
      typeof localStorage !== 'undefined' &&
      localStorage.getItem(LS_KEY) === '1'
    );
  } catch {
    return false;
  }
}

export function logCalendarDebug(topic: string, detail?: unknown): void {
  // if (!isCalendarEventsDebugEnabled()) {
  //   return;
  // }
  const ts = new Date().toISOString();
  if (detail !== undefined) {
    console.info(`[calendar-events ${ts}] ${topic}`, detail);
  } else {
    console.info(`[calendar-events ${ts}] ${topic}`);
  }
}
